import { UtilService } from './../util/util.service';
import { Injectable } from '@angular/core';

declare let paymentV2AB;
declare let frequencyTypAB;
declare let tenureTypAB;
declare let stroy_donation_form_changes;
declare let trial_based_donationAB;
declare let dm_banner_AB;
declare let talk_to_us_AB;
declare let story_one_tap_AB;
declare let slabs_usa_AB;
declare let videopopup_AB;
declare let intent_payu_AB;
declare let otd_to_sip_AB;
declare let social_share_btns;
declare let banner_anniversary_AB;
declare let dm_slab_experiment_AB;
declare let top_supporter_AB;
declare let story_carousel_AB;
declare let razorpay_upi_sip_AB;
declare let story_popup_AB;
declare let homepage_banner_AB;
declare let tickr_mini_story_AB;
declare let ministory_iterations_p2_AB;
declare let sticky_share_AB;
declare let quickDonate_fallback_p1_AB;
declare let fifty_rupee_nudge_AB;
declare let other_amount_AB;
declare let why_ketto_AB;
declare let quickDonate_fr_AB;
declare let story_promo_homeAB;
declare let bulk_donationAB;
declare let slab_AB;
declare let ticker_otd_AB;
declare let tip_on_updateAB;
declare let other_amount_otd_AB;
declare let min_amount_storyAB;
declare let dm_banner_img_AB;
declare let mini_story_slab_AB;
declare let groww_on_ministoryAB;
declare let update_nudge_AB;
declare let repeatorder_ministoryAB;
declare let sip_campaign_DM_AB;
declare let eigthyG_typ_nudge_AB;
declare let bulk_donationv1AB;
declare let dm_banner_new_AB;
declare let min_donation_AB;
declare let razorpay_card_AB;
declare let thankyou_standard_AB;
declare let multicause_dm_AB;
declare let payu_intent_AB;
declare let min_donation_OTD_v1_AB;
declare let min_donation_OTD_v2_AB;
declare let hide_fb_tip_AB;
declare let otd_cartdrop_AB;

@Injectable({
  providedIn: 'root'
})
export class VwoService {

  constructor(
    private utilService: UtilService
  ) { }

  /** Get the variable of tickr AB Test */
  getTickrVariable() {
    if (typeof window !== 'undefined') {
      if (window.location.pathname.includes('/stories/') || this.utilService.isMobile()) {
        return true;
      }
    }
    return false;
  }

  paymentV2AB() {
    if (typeof paymentV2AB !== 'undefined') {
      return paymentV2AB;
    }
  }

  frequencyTypAB() {
    if (typeof frequencyTypAB !== 'undefined') {
      return frequencyTypAB;
    }
  }

  tenureTypAB() {
    if (typeof tenureTypAB !== 'undefined') {
      return tenureTypAB;
    }
  }

  story_donation_form_changesAB() {
    if (typeof stroy_donation_form_changes !== 'undefined') {
      return stroy_donation_form_changes;
    }
  }

  trial_based_donationAB() {
    if (typeof trial_based_donationAB !== 'undefined') {
      return trial_based_donationAB;
    }
  }

  dm_banner_AB() {
    if (typeof dm_banner_AB !== 'undefined') {
      return dm_banner_AB;
    }
  }

  talk_to_us_AB() {
    if (typeof talk_to_us_AB !== 'undefined') {
      return talk_to_us_AB;
    }
  }

  story_one_tap_AB() {
    if (typeof story_one_tap_AB !== 'undefined') {
      return story_one_tap_AB;
    }
  }

  slabs_usa_AB() {
    if (typeof slabs_usa_AB !== 'undefined') {
      return slabs_usa_AB;
    }
  }

  videopopup_AB() {
    if (typeof videopopup_AB !== 'undefined') {
      return videopopup_AB;
    }
  }

  intent_payu_AB() {
    if (typeof intent_payu_AB !== 'undefined') {
      return intent_payu_AB;
    }
  }

  otd_to_sip_AB() {
    if (typeof otd_to_sip_AB !== 'undefined') {
      return otd_to_sip_AB;
    }
  }

  social_share_btns_AB() {
    if (typeof social_share_btns !== 'undefined') {
      return social_share_btns;
    }
    return true;
  }

  banner_anniversary_AB() {
    if (typeof banner_anniversary_AB !== 'undefined') {
      return banner_anniversary_AB;
    }
  }

  top_supporter_AB() {
    if (typeof top_supporter_AB !== 'undefined') {
      return top_supporter_AB;
    }
  }

  story_carousel_AB() {
    if (typeof story_carousel_AB !== 'undefined') {
      return story_carousel_AB;
    }
  }

  dm_slab_experiment_AB() {
    if (typeof dm_slab_experiment_AB !== 'undefined') {
      return dm_slab_experiment_AB;
    }
  }

  razorpay_upi_sip_AB() {
    if (typeof razorpay_upi_sip_AB !== 'undefined') {
      return razorpay_upi_sip_AB;
    }
  }

  story_popup_AB() {
    if (typeof story_popup_AB !== 'undefined') {
      return story_popup_AB;
    }
  }

  homepage_banner_AB() {
    if (typeof homepage_banner_AB !== 'undefined') {
      return homepage_banner_AB;
    }
  }

  tickr_mini_story_AB() {
    if (typeof tickr_mini_story_AB !== 'undefined') {
      return tickr_mini_story_AB;
    }
  }

  ministory_iterations_p2_AB() {
    if (typeof ministory_iterations_p2_AB !== 'undefined') {
      return ministory_iterations_p2_AB;
    }
  }

  sticky_share_AB() {
    if (typeof sticky_share_AB !== 'undefined') {
      return sticky_share_AB;
    }
  }

  quickDonate_fallback_p1_AB() {
    if (typeof quickDonate_fallback_p1_AB !== 'undefined') {
      return quickDonate_fallback_p1_AB;
    }
    // return 'v2';
  }

  quickDonate_fr_AB() {
    if (typeof quickDonate_fr_AB !== 'undefined') {
      return quickDonate_fr_AB;
    }
  }

  fifty_rupee_nudge_AB() {
    if (typeof fifty_rupee_nudge_AB !== 'undefined') {
      return fifty_rupee_nudge_AB;
    }
  }

  other_amount_AB() {
    if (typeof other_amount_AB !== 'undefined') {
      return other_amount_AB;
    }
  }

  why_ketto_AB() {
    if (typeof why_ketto_AB !== 'undefined') {
      return why_ketto_AB;
    }
  }

  story_promo_homeAB() {
    if (typeof story_promo_homeAB !== 'undefined') {
      return story_promo_homeAB;
    }
  }

  bulk_donationAB() {
    if (typeof bulk_donationAB !== 'undefined') {
      return bulk_donationAB;
    }
    // return true;
  }

  slab_AB() {
    if (typeof slab_AB !== 'undefined') {
      return slab_AB;
    }
    // return 'non_inr_ab'
  }

  ticker_otd_AB() {
    if (typeof ticker_otd_AB !== 'undefined') {
      return ticker_otd_AB;
    }
  }

  tip_on_updateAB() {
    if (typeof tip_on_updateAB !== 'undefined') {
      return tip_on_updateAB;
    }
    // return true;
  }

  other_amount_otd_AB() {
    if (typeof other_amount_otd_AB !== 'undefined') {
      return other_amount_otd_AB;
    }
  }

  min_amount_storyAB() {
    if (typeof min_amount_storyAB !== 'undefined') {
      return min_amount_storyAB;
    }
    // return true;
  }

  dm_banner_img_AB() {
    if (typeof dm_banner_img_AB !== 'undefined') {
      return dm_banner_img_AB;
    }
  }

  mini_story_slab_AB() {
    if (typeof mini_story_slab_AB !== 'undefined') {
      return mini_story_slab_AB;
    }
  }

  groww_on_ministoryAB() {
    if (typeof groww_on_ministoryAB !== 'undefined') {
      return groww_on_ministoryAB;
    }
    // return true;
  }

  update_nudge_AB() {
    if (typeof update_nudge_AB !== 'undefined') {
      return update_nudge_AB;
    }
  }

  sip_campaign_DM_AB() {
    if (typeof sip_campaign_DM_AB !== 'undefined') {
      return sip_campaign_DM_AB;
    }
    // return true;
  }

  repeatorder_ministoryAB() {
    if (typeof repeatorder_ministoryAB !== 'undefined') {
      return repeatorder_ministoryAB;
    }
  }

  eigthyG_typ_nudge_AB() {
    if (typeof eigthyG_typ_nudge_AB !== 'undefined') {
      return eigthyG_typ_nudge_AB;
    }
    // return true;
  }

  bulk_donationv1AB() {
    if (typeof bulk_donationv1AB !== 'undefined') {
      return bulk_donationv1AB;
    }
    // return true;
  }

  dm_banner_new_AB() {
    if (typeof dm_banner_new_AB !== 'undefined') {
      return dm_banner_new_AB;
    }
    // return true;
  }

  min_donation_AB() {
    if (typeof min_donation_AB !== 'undefined') {
      return min_donation_AB;
    }
    // return true;
  }

  razorpay_card_AB() {
    if (typeof razorpay_card_AB !== 'undefined') {
      return razorpay_card_AB;
    }
  }

  thankyou_standard_AB() {
    if (typeof thankyou_standard_AB !== 'undefined') {
      return thankyou_standard_AB;
    }
  }

  multicause_dm_AB() {
    if (typeof multicause_dm_AB !== 'undefined') {
      return multicause_dm_AB;
    }
    // return true;
  }

  payu_intent_AB() {
    if (typeof payu_intent_AB !== 'undefined') {
      return payu_intent_AB;
    }
  }

  min_donation_OTD_v1_AB() {
    if (typeof min_donation_OTD_v1_AB !== 'undefined') {
      return min_donation_OTD_v1_AB;
    }
    // return true;
  }

  min_donation_OTD_v2_AB() {
    if (typeof min_donation_OTD_v2_AB !== 'undefined') {
      return min_donation_OTD_v2_AB;
    }
    // return true;
  }

  hide_fb_tip_AB() {
    if (typeof hide_fb_tip_AB !== 'undefined') {
      return hide_fb_tip_AB;
    }
  }

  otd_cartdrop_AB() {
    if (typeof otd_cartdrop_AB !== 'undefined') {
      return otd_cartdrop_AB;
    }
    // return true;
  }

}
